import IncomptibilityAnalysis from './IncompatibilityAnalysis'

export default IncomptibilityAnalysis


// WEBPACK FOOTER //
// ./src/containers/IncompatibilityAnalysis/index.js